import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Hidden,
  ListItemText,
  ListItemIcon,
  Card,
  CardContent,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import logo from "../../../../assets/images/logo/tu-top-ban-logo.png";
import styles from "./Navbar.module.css";
import DropdownButton from "../../basic-component/DropdownButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import {
  faBell,
  faDownLeftAndUpRightToCenter,
  faGears,
  faLanguage,
  faRightLeft,
  faUpRightAndDownLeftFromCenter,
  faFlag,
} from "@fortawesome/free-solid-svg-icons";
import API_Route from "../../../../constants/api-routes";
import axios from "axios";
import { CloseFullscreen } from "@mui/icons-material";
import SideBar from "../SideBar";
import Footer from "../Footer";
import { useRefreshState } from "../../../hooks/useRefreshState";
import { useTranslation } from "react-i18next";
import { setMenuInfo } from "../../../system/redux/reducers/menuReducer";
import { setUserInfo } from "../../../system/redux/reducers/roleReducer";
import Mjlogo from '../../../../assets/images/logo/mj.png';
import LogoThree from '../../../../assets/images/logo/logo-three.png';

import {
  activeProfile,
  apiHostUrl,
  applicationContextRoot,
  datePickerAppDate,
  getConsentListURL,
  homeUrl,
  MISReportDateFormat,
  showRoleSwitchToCustomer,
} from "../../../../constants/constants";

import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import Badge from "react-bootstrap/Badge";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MJlogo from "../../../../assets/images/logo/mj.png";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import ReactModal from "../../basic-component/Modal/AddModalCustomer";
import useAddModal from "../../../hooks/useAddModal";
import { setConsentId } from "../../../system/redux/reducers/consentId";
import DatatTable from "../../basic-component/Table";
import {
  generateAppropriateDate,
  generateAppropriateDateWithConsent,
  minutesToHHMMSS,
} from "../../basic-component/DateUtils";
import { color } from "@mui/system";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { stompClient, disconnectWS, sendLogoutMessage } from "../../basic-component/web-socket/WebSocket";
import { setNavigationData, setPayloadData, setSearchFilterData } from "../../../system/redux/reducers/NavigatedDataReducer";
import moment from "moment/moment";

const tableStyles = {
  width: " 100%",
  height: "auto",
  minWidth: "0",
};
const Navbar = (props) => {

  const today = moment().format(datePickerAppDate);
  var formattedDateToday = moment(today, datePickerAppDate).format(MISReportDateFormat);

  const toDateFormatted = formattedDateToday;
  console.log(toDateFormatted);
  //const fromDateCopy = new Date(today);
  //fromDateCopy.setDate(today.getDate() - 90);
  const fromDateFormatted = moment().subtract(3, 'month').format(datePickerAppDate);
  var formattedDateFrom = moment(fromDateFormatted, datePickerAppDate).format(MISReportDateFormat);
  const fromDate = formattedDateFrom;
  const dispatch = useDispatch();
  const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  console.log("Inside NavBar");
  const [consentList, setConsentList] = useState(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const { i18n, t } = useTranslation();
  const { isAuthenticated } = useSelector((state) => state.userState);
  const [anchorEl, setAnchorEl] = useState(null);
  let [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [ctoken, setCtoken] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const { homeLink } = useSelector((state) => state.role);
  const [
    viewFeedbackDetailsFromConsentList,
    setViewFeedbackDetailsFromConsentList,
  ] = useState(null);
  const [currRole, setCurrRole] = useState("");
  const [email, setEmail] = useState(" ");
  const [userName, setUserName] = useState(" ");
  const { isOpen, toggleModal, val } = useAddModal();
  const [filteredRows, setFilteredRows] = useState([]);

  const [headers, setHeaders] = useState({
    Accept: "*/*",
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const { fetchData: fetchConsentList } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getConsentListURL}`,
    method: "POST",
    onLoad: false, // set onLoad to false to prevent immediate fetching
    headers: headers,
  });

  useEffect(() => {
    setHeaders({
      Accept: "*/*",
      "X-Csrf-Token": csrfToken,
      "Content-Type": "application/json",
    });
  }, [csrfToken]);
  useEffect(() => {
    if (
      homeLink !== "" &&
      !homeLink.includes("prospective") &&
      csrfToken !== null &&
      csrfToken !== undefined &&
      headers["X-Csrf-Token"].length > 0
    ) {
      fetchConsentList().then((data) => {
        if (data !== null && data !== undefined && data !== "") {
          data.sort((a, b) => { return a.remainingTime - b.remainingTime });
          setConsentList(data);
          setNotificationCount(data.length);
        }
      }); // call fetchData when the condition is met
    }
  }, []);

  const menuLangItems = [
    { title: "English", key: "en", icon: faFlag },
    { title: " हिंदी ", key: "hi", icon: faFlag },
  ];

  const onChangeLang = (e) => {
    const lang_code = e.target.value;
    i18n.changeLanguage(lang_code);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (window.innerWidth <= 760) {
      setIsMobile(true);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 760) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    });
  }, []);
  const fullScreenHandler = () => {
    if (document.fullscreenElement) {
      //Component is in fullscreen
      document.exitFullscreen();
      setIsFullscreen(false);
    } else {
      //Requesting to go fullscreen
      setIsFullscreen(true);
      document.documentElement.requestFullscreen().catch((err) => {
        setIsFullscreen(false);
        console.log("Error attempting to enable fullscreen: ", err);
      });
    }
  };
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = () => {
    navigate(applicationContextRoot, { replace: true });
    dispatch({ type: "USER_LOGOUT" });
  };
  const handleLogout = () => {
    console.log("Logout");
    const formData = csrfFormTagName + "=" + csrfToken;
    async function logout(params) {
      const response = await axios
        .post(API_Route.logout, formData, { withCredentials: true })
        .then((res) => {
          debugger
          console.log(res.status);
          if (res.status === 200) {
            debugger
            if (stompClient) {
              var message = {
                senderId: roles.userId,
              }
              sendLogoutMessage('/user-logged-out', message)
              dispatch(setSearchFilterData(
                {
                  "status": "All",
                  "fromDate": fromDate,
                  "toDate": toDateFormatted,
                  "feedbackCode": "",
                  "feedbackType": { "id": "" },
                  "feedbackSource": { "id": "" },
                  "area": { "id": "" },
                  "subArea": { "id": "" },
                  "user": { "id": "", "orgName": "", "email": "", "phone": "", "mobile": "" },
                  "attributeList": [{ "attributeType": "", "departmentAttributeId": "", "attributeId": "", "mandatory": "", "attributeVal": "" }]
                },
              ));
              dispatch(setPayloadData({}));
              const navigationInfo = {
                'navigationPath': 'dashboard',
                'navigationSubPath': "All",
                'data': {}
              }
              dispatch(setNavigationData(navigationInfo));

            }
            handleNavigation();
          }
        });
    }
    logout();
  };

  // const handleDrawerToggle = () => {
  //     setDrawerOpen(!drawerOpen);
  // };
  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  function stringAvatar(name) {
    if (!name || name === null) name = "Anonymous User";
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }
  const roles = useSelector((state) => state.role);
  console.log(roles);
  function toSentenceCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  useEffect(() => {
    console.log("Inside nav");
    console.log(roles);
    let crl = roles.userCurrRole ? roles.userCurrRole.description : "";
    let prefix = roles.userCurrRole
      ? roles.userCurrRole.department.description
      : "";


    setCurrRole(
      toSentenceCase(prefix) +
      " - " +
      toSentenceCase(crl.substring(crl.indexOf("_") + 1))
    );


    setEmail(roles.userEmail);

    setUserName(roles.userName);
  }, [roles, isAuthenticated]);

  const columnData = useMemo(
    () => [
      {
        accessorKey: "ntype",
        header: "Notification Type",
        size: 60,
        // render: (row) => (
        //     <input
        //         type="checkbox"
        //         onChange={() => handleCheckboxChange(row.id)}
        //         checked={selectedRowss.includes(row.id)}
        //     />
        // ),
      },
      {
        id: "desc",
        header: "Description",
        size: 240,
        accessorFn: (row) => row.desc_raw.toLowerCase(),
        Cell: ({ row }) => (
          <div style={{ wordWrap: "break-word" }}>
            {row.original.desc}
          </div>
        ),
      },
      {
        accessorKey: "ndate",
        header: "Notification Date",
        // size:props.size.f_code,
      },
      {
        accessorKey: "naction",
        header: "Action",
        size: 60,
        // render: (row) => (
        //     <div className="d-flex justify-content-center">
        //         <button className="btn btn-primary btn-sm">View</button>
        //     </div>
        // ),
      },
    ],
    []
  );
  useEffect(() => {
    consentList &&
      filteredRows.length === 0 &&
      consentList.forEach((item, index) => {
        // if (item.escalationStep === 0) return;
        // const checkbox = (
        //     <label>
        //         <input
        //             type="radio"
        //             onChange={() => handleCheckboxChange(item.departmentSlaEscalationId)}
        //             checked={selectedRowss.includes(item.departmentSlaEscalationId)}
        //         />
        //         {item.escalationStep} {/* This will display the value next to the radio button */}
        //     </label>

        // );
        setFilteredRows((prevFilteredRows) => {
          return [
            ...prevFilteredRows,
            {
              ntype: "Consent",

              // 👇 display field
              desc: `${t("general.label.Consent.required")} ${item.feedbackCode}`,

              // 👇 FILTER FIELD (IMPORTANT FIX)
              desc_raw: item.feedbackCode,

              ndate: generateAppropriateDateWithConsent(item.comment.createDate),
              naction: (
                <button
                  onClick={() => {
                    toggleModal();
                    dispatch(setConsentId(item.id));
                  }}
                  className="btn btn-primary btn-sm"
                >
                  {t("general.button.view.text")}
                </button>
              ),
            },
          ];
        });
      });
  }, [consentList]);
  return (
    <div>
      <ReactModal
        title={"View All Notification"}
        show={isOpen}
        modalId={"Component"}
        handleClose={toggleModal}
        componentToRender={
          <div>
            <DatatTable
              tableStyles={tableStyles}
              tableData={{ columnData, rowsData: filteredRows }}
            />
          </div>
        }
      ></ReactModal>
      <header className="py-2 border-bottom custom-header bg-white">
        <Container
          fluid
          className="d-flex gap-3 justify-content-between align-items-center"
        >
          <a href="#" className="inside-logo">
            <img 
              src={Mjlogo} 
              onClick={() => props.handleDashboardClick("dashboard")}
             className="cursor-pointer"
            />
            <img src={LogoThree}></img>
          </a>

          <div className="d-flex header_right_area align-items-center">
            <a href="#" className="inside-logo-2">
              <img src={LogoThree}></img>
            </a>
            <div className="w-100 me-2 d-none d-md-block">
              <ul className="nav justify-content-end align-items-center">
                {/* Home Button Start */}
                <li>
                  <div
                    onClick={() => props.handleDashboardClick("dashboard")}
                    className="text-decoration-none text-black"
                    style={{ cursor: "pointer" }}
                  >
                    <OverlayTrigger
                      placement={"bottom"}
                      overlay={<Tooltip>{t('label.general.navigation.home')}</Tooltip>}
                    >
                      <i class="ti ti-home"></i>
                    </OverlayTrigger>
                  </div>
                </li>
                {/* Home Button End */}
                {/* Notification Start */}
                {(currRole.toUpperCase().includes("CST") ||
                  currRole.toUpperCase().includes("SPOC") ||
                  currRole.toUpperCase().includes("RESOLVER") ||
                  currRole.toUpperCase().includes("BU")) && (
                    <>
                      <li>
                        <Dropdown className="notification-dropdown">
                          <Dropdown.Toggle
                            variant="link"
                            id="dropdown-basic"
                            className="p-0 text-decoration-none"
                          >
                            <OverlayTrigger
                              placement={"bottom"}
                              overlay={<Tooltip>{t('general.lable.message.notifications')}</Tooltip>}
                            >
                              <i class="ti ti-bell text-black"></i>
                            </OverlayTrigger>
                            <Badge pill variant="danger" className="small-badge">
                              {notificationCount > 0
                                ? notificationCount > 9
                                  ? "9+"
                                  : notificationCount
                                : ""}
                            </Badge>
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="overflow-hidden">
                            <div className="scroll-area">
                              {consentList && consentList.length === 0 && (
                                <Dropdown.Item>
                                  {" "}
                                  {t("general.lable.message.noConsentFound")}
                                </Dropdown.Item>
                              )}

                              {consentList &&
                                consentList.map((item, index) => {
                                  return (
                                    <Dropdown.Item
                                      onClick={() => {
                                        // debugger;
                                        // setViewFeedbackDetailsFromConsentList(item.id);
                                        // dispatch(setConsentId(0));
                                        dispatch(setConsentId(item.id));
                                      }}
                                      key={index}
                                    >
                                      {t("general.notification.body")}{" "}
                                      <strong>{item.feedbackCode}</strong>
                                      <br />
                                      <small className="text-muted">
                                        {item.remainingTimeStr}{" "}
                                        {t("general.date.duration.postfix")}
                                      </small>
                                    </Dropdown.Item>
                                  );
                                })}
                            </div>

                            {consentList && consentList.length > 0 && (
                              <Dropdown.Item
                                onClick={() => {
                                  toggleModal();
                                }}
                                eventKey="4"
                                className="text-end"
                              >
                                <a className="text-decoration-none">{t("general.label.view.all")}</a>
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    </>
                  )}
                {/* Notification End */}
                {/* Fullscreen Button Start */}
                <li className="d-none d-sm-block">
                  <OverlayTrigger
                    placement={"bottom"}
                    overlay={<Tooltip>{t("general.label.Screen.resize")}</Tooltip>}
                  >
                    <span
                      className="text-decoration-none text-black cursor-pointer"
                      onClick={fullScreenHandler}
                    >
                      {!isFullscreen && <i class="ti ti-maximize"></i>}
                      {isFullscreen && <i class="ti ti-minimize"></i>}
                    </span>
                  </OverlayTrigger>
                </li>
                {/* Fullscreen Button End */}
                {/* Language Switch Start */}
                <li>
                  <DropdownButton
                    className={"language"}
                    icon={faLanguage}
                    Menus={menuLangItems}
                  ></DropdownButton>
                </li>
                {/* Language Switch end */}
                {/* Role Switch start */}
                {showRoleSwitchToCustomer && (
                  <OverlayTrigger
                    placement={"bottom"}
                    overlay={<Tooltip>{t('general.label.role.switch')}</Tooltip>}
                  >
                    <li>

                      <DropdownButton
                        className={"role-switch"}
                        icon={faRightLeft}
                        Menus={roles.roles}
                        moveToDashboard={props.handleDashboardClick}
                      ></DropdownButton>

                    </li>
                  </OverlayTrigger>)}
                {/* Role Switch End */}
              </ul>
            </div>
            <div className="flex-shrink-0 user-info">
              <Dropdown>
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="p-0 d-flex text-decoration-none"
                >
                  <div className="d-block link-dark text-decoration-none">
                    <div class="user_login d-flex align-items-center gap-2">
                      <div class="user-icon">
                        <Avatar {...stringAvatar(userName.toUpperCase())} />
                      </div>
                      <div className="d-none d-sm-block text-start">
                        <p class="mb-0 small user-name-area fw-medium">
                          {email}
                        </p>
                        <small className="designation mb-0">{currRole}</small>
                      </div>
                    </div>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* Mobile toolbar starts */}
                  {isMobile && (
                    <>
                      <div className="d-flex w-100 me-2 justify-content-start">
                        <ul className="nav justify-content-end align-items-center py-1 px-2">
                          {/* Home Button Start */}
                          <li>
                            {" "}
                            <div
                              onClick={() => props.handleDashboardClick("dashboard")}
                              style={{ cursor: "pointer" }}
                            >
                              <i class="ti ti-home"></i>
                            </div>
                          </li>
                          {/* Home Button End */}
                          {/* Notification Start */}
                          {(currRole.toUpperCase().includes("CST") ||
                            currRole.toUpperCase().includes("SPOC") ||
                            currRole.toUpperCase().includes("RESOLVER") ||
                            currRole.toUpperCase().includes("BU")) && (
                              <>
                                <li>
                                  <Dropdown className="notification-dropdown">
                                    <Dropdown.Toggle
                                      variant="link"
                                      id="dropdown-basic"
                                      className="p-0 d-flex text-decoration-none"
                                    >
                                      <i class="ti ti-bell text-black"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="overflow-hidden">
                                      <div className="scroll-area">
                                        <Dropdown.Item href="#">
                                          Lorem Ipsum is simply dummy text
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          It is a long established fact that a
                                          reader{" "}
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Something else
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Contrary to popular belief, Lorem Ipsum
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          sometimes by accident, sometimes on
                                          purpose
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          It is a long established fact that a
                                          reader{" "}
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                          Something else
                                        </Dropdown.Item>
                                      </div>

                                      <Dropdown.Item
                                        eventKey="4"
                                        className="text-end"
                                        disabled
                                      >
                                        <a
                                          href="#"
                                          className="text-decoration-none"
                                        >
                                          {t("general.label.view.all")}
                                        </a>
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </li>
                              </>
                            )}
                          {/* Notification End */}
                          {/* Fullscreen Button Start */}
                          <li className="d-none d-sm-block">
                            <span
                              className="text-decoration-none text-black cursor-pointer"
                              onClick={fullScreenHandler}
                            >
                              {!isFullscreen && <i class="ti ti-maximize"></i>}
                              {isFullscreen && <i class="ti ti-minimize"></i>}
                            </span>
                          </li>
                          {/* Fullscreen Button End */}
                          {/* Language Switch Start */}
                          <li>
                            <DropdownButton
                              className={"language"}
                              icon={faLanguage}
                              Menus={menuLangItems}
                            ></DropdownButton>
                          </li>
                          {/* Language Switch end */}
                          {/* Role Switch start */}
                          <li>
                            {showRoleSwitchToCustomer && (
                              <DropdownButton
                                className={"role-switch"}
                                icon={faRightLeft}
                                Menus={roles.roles}
                                moveToDashboard={props.handleDashboardClick}
                              ></DropdownButton>
                            )}
                          </li>
                          {/* Role Switch End */}
                        </ul>
                      </div>
                      <Dropdown.Divider className="m-0" />

                      <Dropdown.Item>{email}</Dropdown.Item>
                      <Dropdown.Item divider>{currRole}</Dropdown.Item>
                    </>
                  )}

                  <Dropdown.Divider className="m-0" />

                  <Dropdown.Item onClick={handleLogout}>
                    {t("general.msg.logout.text")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </header>
      {/* {roles.userCurrRole && <SideBar />} */}
    </div>
  );
};

export default Navbar;
